import { MFAAttributeName, MFAAttributeNameMap, MFAMethod, MfaError } from '@mobi/api-types/src/mfa'
import { ApiServiceError } from '@core/Services/ApiService'

/** Maps MFA preference values to API attribute names */
const attributeMap: MFAAttributeNameMap = {
  SMS: 'phone_number',
  Email: 'email',
  None: 'none',
  SoftwareToken: 'software_token_mfa_code',
  Unknown: 'unknown',
}
export const mapMFAMethodToAttributeName = (method: MFAMethod): MFAAttributeName => {
  return attributeMap[method] as MFAAttributeName
}

export async function throwApiError(error: unknown): Promise<never> {
  const standardError = await convertToStandardError(error)
  throw standardError
}

export function calculateTimeLeft(expiryTime: number) {
  const difference = expiryTime - Date.now()
  return Math.max(0, Math.floor(difference / 1000))
}

export const formatTime = (seconds: number) => {
  const ts = Math.floor(seconds % 60)
    .toString()
    .padStart(2, '0')
  const tm = Math.floor(seconds / 60)
  return `${tm}:${ts}`
}

// =============
// Local Helpers
// =============

async function convertToStandardError(error: unknown): Promise<MfaError> {
  if (error instanceof ApiServiceError) {
    const response = error.response

    try {
      const errorData = response.status !== 204 ? await response.json() : {}

      return {
        status: response.status,
        error: errorData.error || 'UnknownError',
        message: errorData.message || `Request failed (${response.status})`,
      }
    } catch (jsonError) {
      return {
        status: response.status,
        error: `InvalidResponse: ${jsonError} `,
        message: `Request failed (${response.status})`,
      }
    }
  } else if (error instanceof Error) {
    return {
      status: 500,
      error: error.name,
      message: error.message,
    }
  } else {
    return {
      status: 500,
      error: 'UnknownError',
      message: 'An unknown error occurred',
    }
  }
}
